import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import 'styles/tables.css';
import { DEFAULT_PAGE_SIZE } from '../../CONST';

const shouldShowPagination = (showPagination, resultCount, pageSize) => {
  if (showPagination !== undefined ? showPagination : true) {
    return resultCount > pageSize;
  }
  return false;
};

const BaseTable = ({
  className,
  columns,
  data,
  defaultFilterMethod,
  defaultSorted,
  defaultSortDesc,
  filterable,
  filtered,
  filteredArgs,
  loading,
  onFetchData,
  onFilteredChange,
  onPageChange,
  pages,
  resizable,
  resultCount,
  pageSize=DEFAULT_PAGE_SIZE,
  showPagination,
  style,
  tableRef,
  showBorders,
  sortable,
  getTrProps,
  hideLoadingText=false,
}) => {
  return (
    <ReactTable
      manual
      className={`-highlight ${className || ''}`}
      loadingText={hideLoadingText ? "" : "Cargando..."}
      pageSize={pageSize}
      defaultPageSize={DEFAULT_PAGE_SIZE}
      minRows={1}
      pageText="Página"
      previousText="Anterior"
      nextText="Siguiente"
      noDataText="Sin resultados"
      rowsText="Filas"
      multiSort={false}
      showPageSizeOptions={false}
      showPagination={shouldShowPagination(showPagination, resultCount, pageSize)}
      ref={tableRef}
      resizable={resizable}
      data={data}
      loading={loading}
      pages={pages}
      sortable={sortable}
      filterable={filterable}
      filtered={filtered}
      filteredArgs={filteredArgs}
      columns={columns}
      defaultFilterMethod={defaultFilterMethod}
      defaultSorted={defaultSorted}
      defaultSortDesc={defaultSortDesc || false}
      onPageChange={onPageChange}
      onFetchData={onFetchData}
      onFilteredChange={onFilteredChange}
      style={style}
      getTheadProps={() => ({
        style: {
          background: '#EFEFEF',
        }})
      }
      getTheadThProps={() => ({
        style: {
          border: showBorders ? undefined : 'none',
        }})
      }
      getTrGroupProps={() => ({
        style: {
          border: showBorders ? undefined : 'none',
          borderBottom: '1px solid #CCCCCC',
        }})
      }
      getTdProps={() => ({
        style: {
          border: showBorders ? undefined : 'none'
        },
      })}
      getTableProps={() => ({
        style: { overflowX: 'scroll' },
      })}
      getTrProps={getTrProps}
    />
  );
};

BaseTable.propTypes = [];

export default BaseTable;
